import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../ui/select';

const SECTORES = [
  'Sector Primario', 'Industria', 'Energía', 'Construcción', 'Comercio',
  'Transporte y Logística', 'Turismo y Hostelería', 'Finanzas y Seguros',
  'Educación', 'Sanidad', 'Administración Pública',
  'Consultoría y Servicios Profesionales', 'Tecnología', 'I+D',
  'Telecomunicaciones', 'Servicios de Información', 'Alta Dirección',
  'Cultura y Ocio', 'Otros',
];

const FACTURACION = ['< 1M€', '1–5M€', '5–10M€', '10–25M€', '25–50M€', '+50M€'];
const EMPLEADOS = ['1-10', '11-50', '51-200', '201-500', '+500'];

const inputClass = (hasError) =>
  `w-full px-4 py-3 bg-white border rounded text-sm text-[#00163E] placeholder:text-[#8A9BB1]/60 outline-none transition-colors duration-200 ${
    hasError
      ? 'border-red-400 focus:border-red-500'
      : 'border-[#E4E6EA] focus:border-[#C58C40]'
  }`;

const labelClass = 'block text-sm font-medium text-[#00163E] mb-1.5';
const errorClass = 'text-red-500 text-xs mt-1';

export default function StepIdentificacion({ data, errors, onChange }) {
  return (
    <div className="space-y-5">
      {/* Row 1: Nombre + Cargo */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <div>
          <label className={labelClass}>Nombre completo</label>
          <input
            type="text"
            value={data.nombre}
            onChange={(e) => onChange('nombre', e.target.value)}
            placeholder="Ej: María García López"
            data-testid="field-nombre"
            className={inputClass(errors.nombre)}
          />
          {errors.nombre && <p className={errorClass}>{errors.nombre}</p>}
        </div>
        <div>
          <label className={labelClass}>Cargo</label>
          <input
            type="text"
            value={data.cargo}
            onChange={(e) => onChange('cargo', e.target.value)}
            placeholder="Ej: CEO, Director General"
            data-testid="field-cargo"
            className={inputClass(errors.cargo)}
          />
          {errors.cargo && <p className={errorClass}>{errors.cargo}</p>}
        </div>
      </div>

      {/* Row 2: Email + Teléfono */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <div>
          <label className={labelClass}>Email corporativo</label>
          <input
            type="email"
            value={data.email}
            onChange={(e) => onChange('email', e.target.value)}
            placeholder="correo@empresa.com"
            data-testid="field-email"
            className={inputClass(errors.email)}
          />
          {errors.email && <p className={errorClass}>{errors.email}</p>}
        </div>
        <div>
          <label className={labelClass}>Teléfono</label>
          <input
            type="tel"
            value={data.telefono}
            onChange={(e) => onChange('telefono', e.target.value)}
            placeholder="+34 600 000 000"
            data-testid="field-telefono"
            className={inputClass(errors.telefono)}
          />
          {errors.telefono && <p className={errorClass}>{errors.telefono}</p>}
        </div>
      </div>

      {/* Row 3: Empresa + Provincia/País */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <div>
          <label className={labelClass}>Nombre de la empresa</label>
          <input
            type="text"
            value={data.empresa}
            onChange={(e) => onChange('empresa', e.target.value)}
            placeholder="Empresa S.L."
            data-testid="field-empresa"
            className={inputClass(errors.empresa)}
          />
          {errors.empresa && <p className={errorClass}>{errors.empresa}</p>}
        </div>
        <div>
          <label className={labelClass}>Provincia / País</label>
          <input
            type="text"
            value={data.provinciaPais || ''}
            onChange={(e) => onChange('provinciaPais', e.target.value)}
            placeholder="Ej: Valencia, España"
            data-testid="field-provincia-pais"
            className={inputClass(false)}
          />
        </div>
      </div>

      {/* Row 4: Sector */}
      <div>
        <label className={labelClass}>Sector</label>
        <Select value={data.sector} onValueChange={(val) => onChange('sector', val)}>
          <SelectTrigger
            data-testid="field-sector"
            className={`h-[46px] rounded bg-white text-sm ${
              errors.sector ? 'border-red-400' : 'border-[#E4E6EA] focus:border-[#C58C40]'
            }`}
          >
            <SelectValue placeholder="Seleccionar sector" />
          </SelectTrigger>
          <SelectContent>
            {SECTORES.map((s) => (
              <SelectItem key={s} value={s}>{s}</SelectItem>
            ))}
          </SelectContent>
        </Select>
        {errors.sector && <p className={errorClass}>{errors.sector}</p>}
      </div>

      {/* Row 5: Facturación */}
      <div>
        <label className={labelClass}>Tamaño por facturación</label>
        <div className="flex flex-wrap gap-2 mt-1">
          {FACTURACION.map((f) => (
            <button
              key={f}
              type="button"
              onClick={() => onChange('facturacion', f)}
              data-testid={`field-facturacion-${f}`}
              className={`px-4 py-2.5 text-sm rounded border transition-all duration-200 ${
                data.facturacion === f
                  ? 'border-[#C58C40] bg-[#C58C40]/10 text-[#C58C40]'
                  : 'border-[#E4E6EA] text-[#00163E]/60 hover:border-[#00163E]/30'
              }`}
            >
              {f}
            </button>
          ))}
        </div>
        {errors.facturacion && <p className={errorClass}>{errors.facturacion}</p>}
      </div>

      {/* Row 6: Empleados */}
      <div>
        <label className={labelClass}>Número de empleados</label>
        <div className="flex flex-wrap gap-2 mt-1">
          {EMPLEADOS.map((e) => (
            <button
              key={e}
              type="button"
              onClick={() => onChange('empleados', e)}
              data-testid={`field-empleados-${e}`}
              className={`px-4 py-2.5 text-sm rounded border transition-all duration-200 ${
                data.empleados === e
                  ? 'border-[#C58C40] bg-[#C58C40]/10 text-[#C58C40]'
                  : 'border-[#E4E6EA] text-[#00163E]/60 hover:border-[#00163E]/30'
              }`}
            >
              {e}
            </button>
          ))}
        </div>
      </div>

      {/* Row 7: Referido (opcional) */}
      <div>
        <label className={labelClass}>
          ¿Cómo nos ha conocido? <span className="text-[#8A9BB1] font-normal">(opcional)</span>
        </label>
        <input
          type="text"
          value={data.referido || ''}
          onChange={(e) => onChange('referido', e.target.value)}
          placeholder="Ej: LinkedIn, recomendación de un conocido, Google..."
          data-testid="field-referido"
          className={inputClass(false)}
        />
      </div>
    </div>
  );
}
